
export { CollectionName } from "/codebuild/output/src4181833330/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"